"use client";
import { cn } from "@/utils";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";
import { cva } from "class-variance-authority";
import { useResize } from "@/utils/useResize";
import { Scale } from "@/animations/scale";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "w-[82%] max-w-[480px] ml-[14px] mt-[68px]",
      sm: "w-[82%] max-w-[480px] ml-[14px] mt-[68px]",
      md: "w-[82%] max-w-[480px] ml-[14px] mt-[68px]",
      lg: "max-w-[480px] ml-[10.27%] mt-[72px]",
      xl: "max-w-[500px] ml-[131px] mt-[78px]",
      "2xl": "max-w-[584px] ml-[139px] mt-[83px]",
      "3xl": "max-w-[619px] ml-[148px] mt-[88px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

const variantsContent = cva(" text-black font-medium ", {
  variants: {
    twSize: {
      xs: "text-[28px] leading-tight px-6 py-4",
      sm: "text-[28px] leading-tight px-6 py-4",
      md: "text-[34px] leading-tight px-6 py-4",
      lg: "text-[52px] leading-tight px-8 py-6",
      xl: "text-[56px] leading-tight px-8 py-6",
      "2xl": "text-[60px] leading-tight px-8 py-8",
      "3xl": "text-[64px] leading-tight px-8 py-8",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderHoldCommunity() {
  const { twSize } = useResize();

  return (
    <Scale>
      <WrapperFinder className={cn(variants({ twSize: twSize }))}>
        <HeaderFinder>
          <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">Hold Community</p>
        </HeaderFinder>

        <div className={cn(variantsContent({ twSize: twSize }))}>
          Holdstation AI for the Community, Web3 for Billions
        </div>
      </WrapperFinder>
    </Scale>
  );
}
